module.exports = __webpack_public_path__ + "a6053d5e56184a52fa91e7ebd1d7f77e.jpeg";